/**
 * @param element object
 * @param body object
 */
export default function showHint(element, body, HintService, $filter ){
	var actualHint = HintService.getHintByName(element.attr('hint-message'));

	element.addClass('show-hint-for-item');
	body.append('<div class="hints-overlay"></div>');
	body.append('<div class="hint-tooltip"><p class="title">' + actualHint.title + '</p><p class="text">' + actualHint.text + '</p><a class="understand">' + $filter('translator')('confirm') + '</a></div>');
	body.append('<a class="hints-close btn">' + $filter('translator')('close') + '</a>');
	$('html,body').animate({scrollTop: element.offset().top - 100}, 'slow');
}
